import { createRouter } from 'src/local-logic/mini-router';

console.log('ROUTES', ROUTES);
const router = createRouter({
  routes: [...ROUTES], // 路由表信息
});
console.log('router', router);
export default router;
